import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'flux-actions';
import { AppActionTypes } from '../actions/AppActions';
import { FetchAttributesActionTypes, UPDATE_UNSUBSCRIBE_TOGGLE } from '../actions/AttributeActions';
import UnsubscribeLinkTypes from '../constants/UnsubscribeLinkTypes';
import { SecurityPhoneNumberActionTypes } from '../actions/security/SecurityPhoneNumberActions';
import { DeletePasskeyActionTypes, RenamePasskeyActionTypes, TOGGLE_PASSKEY_DELETE_MODAL, TOGGLE_PASSKEY_RENAME_MODAL } from '../actions/PasskeysActions';
const initialState = ImmutableMap({
  editNamePopoverOpen: false,
  addEmailAddressModalOpen: false,
  editEmailAddressModalOpen: false,
  changePasswordModalOpen: false,
  forgotPasswordModalOpen: false,
  editSignatureModalOpen: false,
  isUnsubscribeToggledOn: false,
  addEmailModal: false,
  changePrimaryModal: false,
  logOutAllSessionsModalOpen: false,
  isDeleteTrustedNumberModal: false,
  isUpdateTrustedNumberModal: false,
  deletePasskeyModalOpen: false,
  renamePasskeyModalOpen: false
});
export default handleActions({
  [AppActionTypes.TOGGLE_EDIT_NAME](state) {
    return state.set('editNamePopoverOpen', !state.get('editNamePopoverOpen'));
  },
  [AppActionTypes.TOGGLE_ADD_EMAIL_ADDRESS_MODAL](state) {
    return state.set('addEmailAddressModalOpen', !state.get('addEmailAddressModalOpen'));
  },
  [AppActionTypes.TOGGLE_EDIT_EMAIL_ADDRESS_MODAL](state) {
    return state.set('editEmailAddressModalOpen', !state.get('editEmailAddressModalOpen'));
  },
  [AppActionTypes.TOGGLE_CHANGE_PASSWORD_MODAL](state) {
    return state.set('changePasswordModalOpen', !state.get('changePasswordModalOpen'));
  },
  [AppActionTypes.TOGGLE_FORGOT_PASSWORD_MODAL](state) {
    return state.set('forgotPasswordModalOpen', !state.get('forgotPasswordModalOpen'));
  },
  [AppActionTypes.TOGGLE_EDIT_SIGNATURE_MODAL](state) {
    return state.set('editSignatureModalOpen', !state.get('editSignatureModalOpen'));
  },
  [UPDATE_UNSUBSCRIBE_TOGGLE](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('isUnsubscribeToggledOn', action.payload.data);
  },
  [FetchAttributesActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const unsubscribeLinkType = action.payload.data.unsubscribeLinkType;
    const isUnsubscribeToggledOn = !!unsubscribeLinkType && unsubscribeLinkType !== UnsubscribeLinkTypes.NO_UNSUBSCRIBE_LINK;
    return state.set('isUnsubscribeToggledOn', isUnsubscribeToggledOn);
  },
  [AppActionTypes.TOGGLE_ADD_EMAIL_MODAL](state) {
    return state.set('addEmailModal', !state.get('addEmailModal'));
  },
  [AppActionTypes.TOGGLE_CHANGE_PRIMARY_MODAL](state) {
    return state.set('changePrimaryModal', !state.get('changePrimaryModal'));
  },
  [AppActionTypes.TOGGLE_LOG_OUT_ALL_SESSIONS_MODAL](state) {
    return state.set('logOutAllSessionsModalOpen', !state.get('logOutAllSessionsModalOpen'));
  },
  [AppActionTypes.TOGGLE_DELETE_TRUSTED_NUMBER_MODAL](state) {
    return state.set('isDeleteTrustedNumberModal', !state.get('isDeleteTrustedNumberModal'));
  },
  [SecurityPhoneNumberActionTypes.DELETE_SECURITY_NUMBER_SUCCESS](state) {
    return state.set('isDeleteTrustedNumberModal', !state.get('isDeleteTrustedNumberModal'));
  },
  [AppActionTypes.TOGGLE_UPDATE_TRUSTED_NUMBER_MODAL](state) {
    return state.set('isUpdateTrustedNumberModal', !state.get('isUpdateTrustedNumberModal'));
  },
  [SecurityPhoneNumberActionTypes.CLICKED_SETUP](state) {
    return state.set('isUpdateTrustedNumberModal', false);
  },
  [TOGGLE_PASSKEY_DELETE_MODAL](state) {
    return state.set('deletePasskeyModalOpen', !state.get('deletePasskeyModalOpen'));
  },
  [TOGGLE_PASSKEY_RENAME_MODAL](state) {
    return state.set('renamePasskeyModalOpen', !state.get('renamePasskeyModalOpen'));
  },
  [DeletePasskeyActionTypes.SUCCESS](state) {
    return state.set('deletePasskeyModalOpen', false);
  },
  [RenamePasskeyActionTypes.SUCCESS](state) {
    return state.set('renamePasskeyModalOpen', false);
  }
}, initialState);